module.exports = __webpack_public_path__ + "img/2.8ff23492.png";